import styled from 'styled-components';
import {
  LOCAL_WIDGET_ID,
  Show,
  WidgetTokenProvider
} from '@elfsight/lib-utils';
import { useCustomJS, useDefineAPISchema } from '@elfsight/widget-js-api';
import { PortalNestProvider } from '@elfsight/widget-modal';
import {
  createCustomCSSPrefixClassName,
  useFontsLoader
} from '@elfsight/widget-ui';
import { StorageProvider } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { meta } from './meta';
import { Embed } from './widget/embed';
import {
  PREVIEW_CONTENT,
  PREVIEW_ORIGINAL_TEXT_ATTRIBUTE
} from './widget/utils/preview-content';
import { Widget } from './widget/widget';

export function WebsiteTranslator() {
  const {
    customJS,
    editMode,
    widgetId = 'test-widget-id',
    widgetToken,
    font,
    renderThumbnailMode
  } = useSettings();

  const customCSSPrefixClassName = createCustomCSSPrefixClassName(
    meta.alias,
    widgetId
  );

  useDefineAPISchema();
  useCustomJS(customJS, editMode || renderThumbnailMode);
  useFontsLoader([font]);

  return (
    <WidgetTokenProvider
      widgetToken={widgetToken}
      widgetId={widgetId ?? LOCAL_WIDGET_ID}
    >
      <StorageProvider widgetId={widgetId} name={meta.name}>
        <PortalNestProvider
          customCSSClassName={customCSSPrefixClassName}
          font={font}
        >
          <Embed customCSSPrefixClassName={customCSSPrefixClassName}>
            <Widget />
          </Embed>

          <Show when={!!editMode && !renderThumbnailMode}>
            <PreviewContent>
              <h3 {...withOriginalText(PREVIEW_CONTENT.title)}>
                {PREVIEW_CONTENT.title}
              </h3>
              <p {...withOriginalText(PREVIEW_CONTENT.description)}>
                {PREVIEW_CONTENT.description}
              </p>
            </PreviewContent>
          </Show>
        </PortalNestProvider>
      </StorageProvider>
    </WidgetTokenProvider>
  );
}

function withOriginalText(value: string) {
  return {
    [PREVIEW_ORIGINAL_TEXT_ATTRIBUTE]: value
  };
}

const PreviewContent = styled.div`
  box-sizing: border-box;
  max-width: 400px;
  padding: 30px;
  border-radius: 20px;
  background-color: rgba(17, 17, 17, 0.02);
  color: rgba(17, 17, 17, 0.7);
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  text-wrap: balance;

  & h3 {
    margin: auto auto 10px;
    font-size: 18px;
    line-height: 24px;
    color: rgb(17, 17, 17);
  }

  & p {
    margin: auto;
  }
`;
